module.exports = __webpack_public_path__ + "static/media/tela_login_xl.ba03f61a.png";